import React from 'react';
import ReactDOM from 'react-dom';
import './css/normalize.css';
import './css/font/font.css';
import './css/variables.css';
import './css/icon-font/css/style.css';
import './css/index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

